module.exports = __webpack_public_path__ + "static/media/dog-with-headphones.a280a3e9.gif";